import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';

import WorkingHoursForm from '../WorkingHoursForm';
import WorkingHoursQuestionsForm from '../WorkingHoursQuestionsForm';
import { company, currentCompany } from '../../../actionTypes';
import { userTypes } from '../../../utils/constants';
import useStyles from './styles';

const WorkingHoursModal = ({
  isOpen,
  onClose,
  companyId,
  dialogProps,
  ownerId,
  withSearchByOwner,
  userType,
  contractorLevel,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { favoriteOwnerList } = useSelector(store => store.company.favoriteOwnerList);

  const initialOwnerId = favoriteOwnerList[0]?.id || ownerId;
  const [selectedOwner, setSelectedOwner] = useState(initialOwnerId);
  const shouldShowQuestions = userType === userTypes.Owner || userType === userTypes.SafetyCouncil;

  useEffect(() => {
    const newOwnerId = favoriteOwnerList[0]?.id || ownerId;
    if (newOwnerId) {
      setSelectedOwner(newOwnerId);
    }
  }, [favoriteOwnerList, ownerId]);

  useEffect(() => {
    if (withSearchByOwner) {
      dispatch({
        type: company.getFavoriteOwnerList.start,
        payload: { contractorId: companyId },
      });
    }
  }, [companyId, dispatch, withSearchByOwner]);

  useEffect(() => {
    if (shouldShowQuestions && selectedOwner && companyId && isOpen) {
      dispatch({
        type: currentCompany.contractorWorkingHoursAnswers.get.start,
        payload: { ownerCompanyId: selectedOwner, contractorCompanyId: companyId, contractorLevel },
      });
    }
  }, [shouldShowQuestions, selectedOwner, companyId, contractorLevel, dispatch, isOpen]);

  return (
    <Dialog onClose={onClose} className={classes.container} open={isOpen} maxWidth="xs" fullWidth {...dialogProps}>
      <DialogTitle className={classes.title}>View Working Hours</DialogTitle>
      {onClose && (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      )}
      <DialogContent className={classes.content}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <WorkingHoursForm
              ownerList={favoriteOwnerList}
              ownerId={selectedOwner}
              onOwnerChange={setSelectedOwner}
              contractorId={companyId}
              withSearchByOwner={withSearchByOwner}
              readOnly
              userType={userType}
              withExportWorkingHours
              withNotes={userType !== userTypes.Contractor}
            />
          </Grid>
          {shouldShowQuestions && (
            <Grid item xs={12}>
              <WorkingHoursQuestionsForm ownerCompanyId={selectedOwner} contractorCompanyId={companyId} />
            </Grid>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default WorkingHoursModal;
